// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import { store } from '../../../store/store';
import { redirect } from 'react-router';
import { fetchShowById, fetchShowScenes, createBlock } from '../../../store/shows/showsActions';
import { clearShow } from '../../../store/shows/showsSlice';
import { fetchShowScripts } from '../../../store/scripts/scriptsActions';
import { clearClipboard } from '../../../store/scripts/scriptsSlices';

export async function showByIdLoader({ params }) {
  const { showId } = params;
  const companyUuid = store.getState().companies.company?.company_uuid;
  // Store the last companyUuid to detect company change in shouldRevalidate
  showByIdLoader.lastCompanyUuid = companyUuid;

  if (!showId) {
    return null;
  }
  // Clear existing show data
  await store.dispatch(clearShow());
  // fetch show data
  const show = await store.dispatch(fetchShowById(showId)).unwrap();

  // if show does not belong to current company, redirect to shows list
  if (show.company_uuid !== companyUuid) {
    return redirect('/');
  }

  const showUuid = show?.show_uuid;
  const showBlocks = show?.show_blocks || [];
  if (showUuid && !showBlocks.length) {
    // If show has no blocks, create a default block
    await store
      .dispatch(
        createBlock({
          show,
          data: { show_uuid: showUuid, name: 'Block 1' },
        })
      )
      .unwrap();
  }
  store.dispatch(fetchShowScenes(showId));
  store.dispatch(fetchShowScripts(showId));
  store.dispatch(clearClipboard());
  return null;
}

showByIdLoader.hydrate = true;
